/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { TextLink } from '@neo4j-ndl/react';
import { type Meta, type StoryObj } from '@storybook/react-vite';

import {
  TextLinkDefault,
  TextLinkDefaultSource,
  TextLinkExternal,
  TextLinkExternalSource,
  TextLinkInternalIcon,
  TextLinkInternalIconSource,
  TextLinkInternalUnderline,
  TextLinkInternalUnderlineSource,
} from '.';

const componentMeta: Meta<typeof TextLink> = {
  title: 'Components/TextLink',
  id: 'components-text-link',
  component: TextLink,
  tags: ['docsPage'],
  decorators: [
    (Story) => (
      <div className="n-flex n-justify-center">
        <Story />
      </div>
    ),
  ],
};

export default componentMeta;
type Story = StoryObj<typeof TextLink>;

export const Default: Story = {
  args: {},
  render: TextLinkDefault,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: TextLinkDefaultSource,
      },
    },
  },
};

export const InternalUnderline: Story = {
  args: {},
  render: TextLinkInternalUnderline,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: TextLinkInternalUnderlineSource,
      },
    },
  },
};

export const External: Story = {
  args: {},
  render: TextLinkExternal,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: TextLinkExternalSource,
      },
    },
  },
};

export const InternalIcon: Story = {
  args: {},
  render: TextLinkInternalIcon,
  parameters: {
    docs: {
      source: {
        language: 'tsx',
        type: 'code',
        code: TextLinkInternalIconSource,
      },
    },
  },
};
